import { createSlice } from '@reduxjs/toolkit';
import theme from '../../utils/themes';

const initialTheme = { theme: { ...theme }, previewTheme: null };

const slice = createSlice({
  name: 'theme',
  initialState: initialTheme,
  reducers: {
    setTheme: (state, { payload }) => {
      const themeName = payload.isPreview ? 'previewTheme' : 'theme';
      const updatedTheme = {
        ...state,
        [themeName]: { ...(state[themeName] ?? theme), ...payload.theme },
      };
      if (!payload.isPreview) updatedTheme.previewTheme = null;
      return updatedTheme;
    },
    resetTheme: () => ({ ...initialTheme }),
  },
});

export const { setTheme, resetTheme } = slice.actions;

export default slice.reducer;
